// EventFeatureAnalyzer.js

export function getLodgingCoverage(event) {
    const eventDates = event.time_table?.dates?.map(d => d.date) || [];
    if (!eventDates.length || !event.lodging?.length) return 0;

    // Create a map to track lodging presence per event date
    const coverageMap = {};
    eventDates.forEach(date => coverageMap[date] = false);

    // Mark dates as covered if any lodging overlaps
    event.lodging.forEach(lodge => {
        const lodgeDates = lodge.time_table?.dates?.map(d => d.date) || [];
        lodgeDates.forEach(date => {
            if (coverageMap.hasOwnProperty(date)) {
                coverageMap[date] = true;
            }
        });
    });

    // Count how many event dates are covered
    const coveredCount = Object.values(coverageMap).filter(Boolean).length;

    console.log(`Lodging coverage: ${coveredCount} out of ${eventDates.length} days`);

    return Math.round((coveredCount / eventDates.length) * 100);
}

export function getMealCoverage(event) {
    const eventDates = event.time_table?.dates?.map(d => d.date) || [];
    if (!eventDates.length || !event.meals?.length) {
        return {
            breakfast: 0,
            brunch: 0,
            lunch: 0,
            snack: 0,
            dinner: 0,
            dessert: 0
        };
    }

    // Create maps per meal type
    const mealTypes = {
        breakfast: {},
        brunch: {},
        lunch: {},
        snack: {},
        dinner: {},
        dessert: {}
    };

    // Initialize with false for each event date
    eventDates.forEach(date => {
        Object.keys(mealTypes).forEach(type => {
            mealTypes[type][date] = false;
        });
    });

    // Mark covered days by type
    event.meals.forEach(meal => {
        const name = meal.name?.toLowerCase();
        const mealDates = meal.time_table?.dates?.map(d => d.date) || [];

        if (mealTypes[name]) {
            mealDates.forEach(date => {
                if (mealTypes[name].hasOwnProperty(date)) {
                    mealTypes[name][date] = true;
                }
            });
        }
    });

    // Calculate coverage for each type
    const result = {};
    Object.entries(mealTypes).forEach(([type, map]) => {
        const coveredCount = Object.values(map).filter(Boolean).length;
        result[type] = Math.round((coveredCount / eventDates.length) * 100);
    });

    return result;
}


export function getActivityCoverage(event) {
    const eventDates = event.time_table?.dates?.map(d => d.date) || [];
    if (!eventDates.length || !event.activities?.length) return 0;

    const coverageMap = {};
    eventDates.forEach(date => coverageMap[date] = false);

    event.activities.forEach(activity => {
        const actDates = activity.time_table?.dates?.map(d => d.date) || [];
        actDates.forEach(date => {
            if (coverageMap.hasOwnProperty(date)) {
                coverageMap[date] = true;
            }
        });
    });

    const coveredCount = Object.values(coverageMap).filter(Boolean).length;

    console.log(`Activity coverage: ${coveredCount} out of ${eventDates.length} days`);

    return Math.round((coveredCount / eventDates.length) * 100);
}
